import isNumber from './is-number';
/**
 * 判断值是否为奇数
 * @return 是否为奇数
 */
export default function isOdd(num) {
    return isNumber(num) && num % 2 !== 0;
}
//# sourceMappingURL=is-odd.js.map